import { AlignmentType, BorderStyle, HeadingLevel, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, VerticalAlign, WidthType } from "docx";


export const overviewHeading = new Paragraph({
    spacing: { before: 150, after: 300 },
    children: [new TextRun({
        text: "3.  Application Overview",
        bold: true
    })],
    heading: HeadingLevel.HEADING_2,
})


export function overviewPage1(certInAppDescription) {
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { line: 276, before: 450, after: 300 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: certInAppDescription,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
        ],
    })
}

export const objectiveHeading = new Paragraph({
    spacing: { before: 150, after: 300 },
    children: [new TextRun({
        text: "4.  Objectives and Scope",
        bold: true
    })],
    heading: HeadingLevel.HEADING_2,
})

export function objectivePage1(certInApplicationName) {
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { line: 276, before: 450, after: 300 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: `ISECURION security testing team performed Web Application Security Audit on ${certInApplicationName} Web Application. The overall objective and goal of this engagement was to:`,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
        ],
    })
}

export function objectiveBulletOne(certInApplicationName) {
    return new Paragraph({
        indent: { left: 600 },
        bullet: { level: 0 },
        spacing: { line: 350, after: 10 * 72 * 0.05 },
        children: [
            new TextRun({
                text: `Identify Vulnerabilities in ${certInApplicationName} Web Application.`,
                size: 22,
                font: "Calibri",
                bullet: { level: 0 },
                color: '000000',
                italics: false
            })
        ]
    })
}


export const objectiveBulletTwo = new Paragraph({
    indent: { left: 600 },
    bullet: { level: 0 },
    spacing: { line: 350 },
    children: [
        new TextRun({
            text: "Recommended steps that need to be in place to mitigate the risks that arise due to the existence of these vulnerabilities.",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})

export const objectiveBulletThree = new Paragraph({
    indent: { left: 600 },
    bullet: { level: 0 },
    spacing: { line: 350, after: 10 * 72 * 0.05 },
    children: [
        new TextRun({
            text: "Compliance to industry standards and security best practices.",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})

export const scopeHeading = new Paragraph({
    spacing: { before: 450, after: 300 },
    children: [new TextRun({
        text: "Scope",
        bold: true,
        color: "c00000",
        size: 26,
        font: "Cambria"
    })],
})

export function scope1(certInCustomerName) {
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { line: 276, before: 450, after: 300 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: `ISECURION performed Web Application Security Audit on the below mentioned Web Application provided by ${certInCustomerName}.`,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
        ],
    })
}


export function scopeTable(certInApplicationName, certInApplicationUrl) {
    return new Table({
        width: { size: 100, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.CENTER,
        spacing: { before: 450 },
        borders: {
            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        },
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        verticalAlign: VerticalAlign.CENTER,
                        width: { size: 9, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Sl. No",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "003366" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        width: { size: 22, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Application Name",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "003366" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        width: { size: 55, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,

                                children: [
                                    new TextRun({
                                        text: "URL",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "003366" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        width: { size: 14, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Version",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "003366" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 190, after: 190 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "1",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 190, after: 190 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: certInApplicationName,
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false
                                    }),

                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: certInApplicationUrl.split(/\s+/).map((url) =>
                            new Paragraph({
                                spacing: { before: 190, after: 190 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: url,
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false
                                    })
                                ]
                            })
                        ),
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 190, after: 190 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "-",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                ]
            }),
        ]
    })
}